import { ALL_COMPONENTS_INTERSECTION_TYPE, UiComponent } from '../../../interfaces/pagebuilder';

interface SizeTemplateControlProps {
  children: React.ReactNode;
  showControl: boolean;
  onResizeTop: (position: number) => void;
  onResizeBottom: (position: number) => void;
  onStopResizeTop: (position: number) => void;
  onStopResizeBottom: (position: number) => void;
  uiComponent: ALL_COMPONENTS_INTERSECTION_TYPE | UiComponent<{}> | undefined;
}

export const SizeTemplateControl = (props: SizeTemplateControlProps) => {
  const { onResizeTop, onResizeBottom, onStopResizeTop, onStopResizeBottom, showControl, uiComponent } = props;

  // On drag start
  const onMouseDown = (e: any, direction: 'top' | 'bottom') => {
    e.preventDefault();
    if (direction === 'top') {
      window.addEventListener('mousemove', resizeTop);
      window.addEventListener('mouseup', stopResizeTop);
      return;
    }
    window.addEventListener('mousemove', resizeBottom);
    window.addEventListener('mouseup', stopResizeBottom);
  };

  const resizeTop = (e: MouseEvent) => {
    onResizeTop(e.clientY);
  };

  const resizeBottom = (e: MouseEvent) => {
    onResizeBottom(e.clientY);
  };

  const stopResizeTop = async (e: MouseEvent) => {
    window.removeEventListener('mousemove', resizeTop);
    onStopResizeTop(e.clientY);
    window.removeEventListener('mouseup', stopResizeTop);
  };

  const stopResizeBottom = async (e: MouseEvent) => {
    window.removeEventListener('mousemove', resizeBottom);
    onStopResizeBottom(e.clientY);
    window.removeEventListener('mouseup', stopResizeBottom);
  };

  return (
    <>
      <div
        className={`absolute top-0 left-0 w-full h-full border-2 ${
          showControl ? 'opacity-100' : 'opacity-0'
        } transition-opacity overflow-hidden z-50 pointer-events-none`}
        style={{ borderColor: 'var(--vystem-blue)', borderStyle: uiComponent?.accessType !== 'anyone' ? 'dashed' : 'solid' }}>
        <div className="absolute w-full p-4 pointer-events-auto -top-6 cursor-n-resize" onMouseDown={(e) => onMouseDown(e, 'top')} style={{ zIndex: 100 }}>
          <div className="w-full h-2 border-2 bg-blue " style={{ borderColor: 'var(--vystem-blue)' }} />
        </div>
        <div
          className="absolute w-full p-4 pointer-events-auto -bottom-6 cursor-s-resize"
          onMouseDown={(e) => onMouseDown(e, 'bottom')}
          style={{ zIndex: 100 }}>
          <div className="w-full h-2 bg-white border-2 " style={{ borderColor: 'var(--vystem-blue)' }} />
        </div>
      </div>
      {props.children}
    </>
  );
};
